<template>
  <section class="black-bg">
    <div class="calendarContainer">
      <img src="../assets/ornament_rotator.svg" class="rotator" />
      <div class="calendar">
        <h3>Mark Your <span class="text-outline">Calendar</span></h3>
        <div class="calendar__list">
          <div
            class="faq"
            v-for="(value, groupSpeaker) in groupSpeakers"
            :key="value.i"
          >
            <h4 class="calendar-heading">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 20 20"
                fill="#18fb8e"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                  clip-rule="evenodd"
                />
              </svg>
              {{
                new Date(groupSpeaker).toLocaleDateString("en-us", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
              }}
            </h4>
            <div>
              <div v-for="item in value" :key="item.i">
                <div @click="clickEventBox(item)">
                  <div class="calendar-event main-speaker">
                    <div class="calendar-event__left">
                      <div class="calendar-timing">
                        <h5>
                          {{ item.events_start_time | onlyTime }} -
                          {{ item.events_end_time | onlyTime }}
                          <span>UTC</span>
                        </h5>
                        <h5>
                          {{ item.event_start_nepal_time }} -
                          {{ item.event_end_nepal_time }}
                          <span>NPT</span>
                        </h5>
                      </div>
                    </div>
                    <div class="calendar-event__line"></div>
                    <div class="calendar-event__right">
                      <h5>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="#18FB8E"
                        >
                          <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                          /></svg
                        >{{ item.events_title }}
                      </h5>
                      <p>Presented by {{ item.events_presenter }}</p>
                    </div>
                    <span class="random">{{ item.event_abstract }}</span>
                  </div>
                </div>

                <!-- lightining talks -->
                <div
                  class="calendar-event lightning-speaker"
                  v-if="item.lightning_title || item.lightning_presenter"
                >
                  <div class="calendar-event__left">
                    <div class="calendar-timing">
                      <h5>
                        {{ item.lightning_start_time_utc | onlyTime }} -
                        {{ item.lightning_end_time_utc | onlyTime }}
                        <span>UTC</span>
                      </h5>
                      <h5>
                        {{ item.lightning_start_nepal_time }} -
                        {{ item.lightning_end_nepal_time }}
                        <span>NPT</span>
                      </h5>
                    </div>
                  </div>
                  <div class="calendar-event__line"></div>
                  <div class="calendar-event__right">
                    <h5>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="#18FB8E"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                          clip-rule="evenodd"
                        /></svg
                      >{{ item.lightning_title }}
                    </h5>
                    <p>Presented by {{ item.lightning_presenter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchDataFromBase } from "../services/fetchDataFromBase";
import { bus } from "../main";

export default {
  name: "Calendar",
  data() {
    return {
      speakers: "",
      groupSpeakers: {},
    };
  },
  methods: {
    getDateTimeUTC: function(date, time) {
      const dateTime = date && time ? `${date} ${time}` : date;
      const nptDateTime = new Date(dateTime).toUTCString();
      return nptDateTime;
    },
    clickEventBox(props) {
      bus.$emit("openSideboxEvent", [props]);
      document.body.classList.add("overflow-fix");
    },
  },
  filters: {
    onlyDate: function(value) {
      return value.split(",")[0];
    },
    onlyTime: function(value) {
      return value.split(" ")[4].substring(0, 5);
    },
  },
  watch: {
    speakers(newSpeakers) {
      const groupByDate = newSpeakers.reduce((acc, d) => {
        return Object.assign(acc, {
          [d.events_date]: (acc[d.events_date] || []).concat({
            events_abstract: d.event_abstract,
            events_presenter: d.events_presenter,
            event_start_nepal_time: d.events_start_time,
            event_end_nepal_time: d.events_end_time,
            lightning_start_nepal_time: d.lightning_start_time,
            lightning_end_nepal_time: d.lightning_end_time,
            lightning_title: d.lightning_title,
            lightning_presenter: d.lightning_presenter,
            events_start_time: this.getDateTimeUTC(
              d.events_date,
              d.events_start_time
            ),
            events_end_time: this.getDateTimeUTC(
              d.events_date,
              d.events_end_time
            ),
            events_title: d.events_title,
            lightning_start_time_utc: this.getDateTimeUTC(
              d.events_date,
              d.lightning_start_time
            ),
            lightning_end_time_utc: this.getDateTimeUTC(
              d.events_date,
              d.lightning_end_time
            ),
          }),
        });
      }, {});

      this.groupSpeakers = groupByDate;
    },
  },
  async created() {
    const dataSpeakers = await fetchDataFromBase("events");
    this.speakers = dataSpeakers;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.calendar-event {
  display: grid;
  grid-template-columns: auto 20% 1fr;
  gap: 0rem 0rem;
  grid-auto-flow: row;
  grid-template-areas: "calendar-event__left calendar-event__line calendar-event__right";
  width: 100%;
  cursor: pointer;
}

.calendar-event__left {
  grid-area: calendar-event__left;
  align-self: top;
}

.calendar-event__line {
  grid-area: calendar-event__line;
  align-self: top;
}

.calendar-event__right {
  grid-area: calendar-event__right;
  align-self: top;
}

.calendar-event__right svg {
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
}

.calendar-event.main-speaker:before {
  content: "👉";
  padding-left: 1rem;
  transition: 0.1s ease-in-out;
  position: absolute;
  left: -8rem;
  top: 0.2rem;
  opacity: 0;
}
.calendar-event.lightning-speaker {
  cursor: default;
}
.calendar-event.main-speaker:hover.calendar-event:before {
  display: initial;
  left: -4rem;
  opacity: 1;
  transform: scale(1.6);
}

h5 {
  margin: 0px;
}
.calendarContainer {
  max-width: 920px;
  margin: auto;
  padding: 6rem 2.5rem;
  margin-bottom: 4.3rem;
  position: relative;
}
.calendar h3 {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 2rem;
  color: var(--text-white);
}
.calendar-event__line {
  content: "a";
  display: block;
  width: 50%;
  height: 1px;
  border-bottom: 1px solid var(--text-white);
  margin-top: 1rem;
  margin-left: 2rem;
}
.calendar-event {
  margin-top: 2rem;
  margin-bottom: 3.5rem;
  position: relative;
}
.calendar-heading-slug {
  -webkit-text-stroke: 1px var(--text-white);
  color: var(--bg-black);
  font-size: 2rem;
  margin-right: 1rem;
  padding-right: 1rem;
  border-right: 0.5px solid var(--lighter-grey);
}
.calendar-heading {
  font-size: 2rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.calendar-heading > svg {
  margin-right: 1rem;
}
.calendar-event {
  color: var(--text-white);
}
.calendar .text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}
.calendar-timing {
  display: flex;
  flex-direction: column;
  font-weight: 700;
  font-size: 1.1rem;
}
h5 {
  font-size: 1.4rem;
}
.calendar-timing h5 span {
  color: var(--text-white);
}
.calendar-timing small {
  color: var(--lighter-grey);
  font-weight: 100;
  padding-top: 0.2rem;
}
.rotator {
  width: 410px;
  opacity: 0.25;
  position: absolute;
  left: -60%;
}
.calendar-event__right p {
  color: var(--lighter-grey);
  font-weight: 100;
  padding-top: 0.2rem;
}
@media (max-width: 992px) {
  .rotator {
    left: -30%;
  }
}
@media (max-width: 576px) {
  .calendar-event {
    display: flex;
    flex-direction: column;
  }
  .calendar-event__line {
    visibility: hidden;
  }
  .calendarContainer {
    padding: 2rem 2.5rem;
  }
}
</style>
